import React from "react";
import logo from '../../../static/frontend/assets/images/logo_circular.png';

const Spinner = (props) => (
    <div className="f1078404_cont">
        <div className="f1078404_sup">
            <div className="f978404_petit">
                <div className="f1078404_fond">
                    <img src={logo} alt="Loader Logo" className="spinner-logo" />
                    <div className="f1078404"></div>
                </div>
            </div>
        </div>
    </div>

);

export default Spinner;

